module.exports = __webpack_public_path__ + "static/media/heart-necklace.fad66171.svg";